const FILE_VISUALS = [
  { kind: 'pdf', iconClass: 'fa-file-pdf', extensions: ['pdf'] },
  { kind: 'word', iconClass: 'fa-file-word', extensions: ['doc', 'docx'] },
  { kind: 'excel', iconClass: 'fa-file-excel', extensions: ['xls', 'xlsx', 'xlsm', 'csv'] },
  { kind: 'powerpoint', iconClass: 'fa-file-powerpoint', extensions: ['ppt', 'pptx'] },
  { kind: 'archive', iconClass: 'fa-file-zipper', extensions: ['zip', 'rar', '7z', 'gz', 'tar'] },
  { kind: 'image', iconClass: 'fa-file-image', extensions: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'heic'] },
  { kind: 'video', iconClass: 'fa-file-video', extensions: ['mp4', 'mov', 'avi', 'webm', 'mkv'] },
  { kind: 'audio', iconClass: 'fa-file-audio', extensions: ['mp3', 'wav', 'm4a', 'aac', 'flac'] },
  { kind: 'text', iconClass: 'fa-file-lines', extensions: ['txt', 'text', 'md', 'rtf', 'log'] },
];

export const getFileVisual = (fileName = '', fileType = '') => {
  const normalizedName = String(fileName || '').trim().toLowerCase();
  const normalizedType = String(fileType || '').trim().toLowerCase();
  const extension = normalizedName.includes('.') ? normalizedName.split('.').pop() || '' : '';
  if (normalizedType.includes('pdf')) return FILE_VISUALS[0];
  if (normalizedType.includes('word')) return FILE_VISUALS[1];
  if (normalizedType.includes('sheet') || normalizedType.includes('excel')) return FILE_VISUALS[2];
  if (normalizedType.includes('presentation') || normalizedType.includes('powerpoint')) return FILE_VISUALS[3];
  if (normalizedType.includes('zip')) return FILE_VISUALS[4];
  if (normalizedType.startsWith('image')) return FILE_VISUALS[5];
  if (normalizedType.startsWith('video')) return FILE_VISUALS[6];
  if (normalizedType.startsWith('audio')) return FILE_VISUALS[7];
  return (
    FILE_VISUALS.find((visual) => visual.extensions.includes(extension)) || {
      kind: 'generic',
      iconClass: 'fa-file',
    }
  );
};

export const getFileIconClass = (fileName = '') => getFileVisual(fileName).iconClass;
